//A very simple internationalization

let local_i18n = {
  lang: {
    field_required: "Dieses Feld ist ein Pflichtfeld.",
    field_boolean: "Bitte wählen Sie einen Wert.",
    field_numbers_only: "Bitte nur Zahlen angeben.",
    field_min_length: "Mindestens {count} Zeichen angeben.",
    field_max_length: "Maximal {count} Zeichen angeben.",
    field_max_lines: "Bitte maximal {count} Zeilen.",
    field_min_array_length:   " | "+
                              "Mindestens {count} Eintrag. | "+
                              "Mindestens {count} Einträge.",
    field_max_array_length:   " | "+
                              "Maximal {count} Eintrag. | "+
                              "Maximal {count} Einträge.",
    field_url: "Muss eine gültige URL sein (z.B. https://www.domain.com).",
    field_email: "Dies ist keine gültige E-Mail-Adresse.",
    field_true: "Bitte hier bestätigen.",
    field_date: "Dies ist kein gültiges Datum.",

    fileManagementError_maxFileSizeSingle: 'Die Dateigröße der einzelnen Dateien darf {string} nicht übersteigen!',
    fileManagementError_maxFileSizeSum: 'Insgesamt sind nur {string} zulässig!',
    fileManagementError_wrongMimeType: 'Dieser Dateityp wird nicht unterstützt.',
    fileManagementError_toManyFiles: 'Bitte maximal {count} Dateien. | Bitte maximal {count} Datei. | Bitte maximal {count} Dateien.',

    fileCount: '{count} Dateien | {count} Datei | {count} Dateien'
  }
};

local_i18n.t = (key, value) => {
  if(local_i18n.lang[key]===undefined) return key;

  let result = local_i18n.lang[key];
  if(typeof value === 'string') {
    result = result.replace('{string}', value).trim();
  }
  return result;
}

local_i18n.tc = (key,value) => {
  let values = local_i18n.t(key).split('|');
  if(typeof value === 'number') {
    if(value > 1 && values[2]) return values[2].replace('{count}',value).trim();
    if(value===1 && values[1]) return values[1].replace('{count}',value).trim();
    if(value===0 && values[0]) return values[0].replace('{count}',value).trim();
    if(values[0]) return values[0].replace('{count}',value).trim();
  }
  return value;
}

export default local_i18n;
